/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ organizationId: ZodTypes.Id });

export const GetOrganizationRegistrationInvitations = {
  id: 'organization-registration-invitations.get',
  tag: 'Organization',
  summary: 'Get organization registration invitations',
  description: 'Retrieve all registration invitations of an organization',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/organization/${params.organizationId}/user/registration-invitation`,
  request: { params: Params },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.array(
            z.strictObject({
              email: z.string().email(),
              expiry: z.date(),
            }),
          ),
        },
      },
    },
  },
} as const satisfies Endpoint;
